module.exports = __webpack_public_path__ + "static/media/DropboxIcon.5ba9a2a2.svg";